



















































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ReservationTableMobileTile from "./ReservationTableMobileTile.vue";
import ScrollLoader from "@/components/misc/ScrollLoader.vue";
const ComponentRenderOverlay = () => import("@/components/misc/ComponentRenderOverlay.vue");
const ReservationModalMobile = () => import("@/components/reservation-form/ReservationModalMobile.vue");
import MobileFilterModal from "@/components/misc/MobileFilterModal.vue";
import { Getter } from "vuex-class";
import { DateTime } from "luxon";
import { JwtClaims } from "@/store/modules/auth";
import { policyChecker } from "@/shared/roles";

@Component({
  components: {
    ReservationTableMobileTile,
    ReservationModalMobile,
    MobileFilterModal,
    ScrollLoader,
    ComponentRenderOverlay
  },
})

export default class ReservationsTableMobile extends Vue {
  @Getter("calendar/currentDay") currentDay?: DateTime;
  @Getter("language/language") language?: string;
  @Getter("showDatePicker") showDatePicker?: boolean;
  @Prop() reservations?: any[];
  @Prop() name?: string;
  @Prop() fpNum?: number;
  @Prop() endpoint?: string;

  @Getter("auth/claims") claims?: JwtClaims;
  get allowedToModifyReservations() {
    return policyChecker("MODIFY_RESERVATIONS")(this.claims);
  }

  @Getter("appParams/reservationsGridFiltersByDate") reservationsGridFiltersByDate?: number;
  @Getter("reservations/dateFilterApplied") dateFilterApplied?: boolean;
  
  sortOptions: { text: string; value: string }[] = [];
  sortOrder = "asc";
  currentSortField =  this.reservationsGridFiltersByDate === 1 ? "VReservation.arrivalDate" : "VReservation.departureDate"

  elementDate = 0;

  renderReservationModalMobile = false;
  isReservationsGridFilteredByDate = true;

  async applyReservationsGridFilter() {
    await this.$store.dispatch("reservations/setDateFilterApplied", this.isReservationsGridFilteredByDate)
  }
  
  @Watch("sortOrder")
  sortOrderChanged(fresh: string)
  {
    if(this.reservations)
    {
      if(fresh === "asc")
      {
        this.$emit("sortOrder", false);
      }
      if(fresh === "desc")
      {
        this.$emit("sortOrder", true);
      }
    }
  }

  scrollEl = null as HTMLElement | null;
  mounted() {
    if(this)
    {
      this.scrollEl = (this as Vue).$el.querySelector(".units-wrapper");
    }
  }

  firstUpper(string: string): string {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }

  changeSortOrder()
  {
    if(this.sortOrder === "asc")
    {
      this.sortOrder = "desc";
    }
    else {
      this.sortOrder = "asc";
    }
  }

  sortByOrder(value: string) {
    this.$emit("sortByOrder", value);
    if (value === "arrivalDate") {
      this.currentSortField = "VReservation.arrivalDate";
    } else if (value === "departureDate") {
      this.currentSortField = "VReservation.departureDate"
    } else if (value === "bookingDate") {
      this.currentSortField = "VReservation.bookingDate"
    } else {
      this.currentSortField = value;
    }
  }

  scrolled() {
    if(this.scrollEl?.scrollTop)
    {
      if(this.scrollEl?.scrollTop <= 72)
      {
        const floor = Math.floor(this.scrollEl?.scrollTop / 100)
        if(floor !== this.elementDate && floor >= 0)
        {
          this.elementDate = floor;
        }
      }
      else {
        const floor = Math.floor((this.scrollEl?.scrollTop + 148) / 248)
        if(floor !== this.elementDate && floor >= 0)
        {
          this.elementDate = floor;
        }
      }
    }
  }

  reservationFormId: number | null = null;
  scrollId: string | null = null;
  reservationFormOpen = false;

  addItem(){
    this.reservationFormId = null;
    this.scrollId = null;
    this.renderReservationModalMobile = true;
    this.reservationFormOpen = true;
  }

  editItem(event: any){
    this.reservationFormId = event.resId;
    this.scrollId = event.scrollId;
    this.renderReservationModalMobile = true;
  }

  created() {
    this.sortOptions = [
      { text: "VReservation.arrivalDate", value: "arrivalDate" },
      { text: "VReservation.departureDate", value: "departureDate" },
      { text: "VReservation.bookingDate", value: "bookingDate" }
    ];
  }
  get occupancy() {
    return this.name === "Dashboard.Occupancy";
  }

  get tabName() {
    if(this.name)
    {
      return this.$t(this.name).toString().toUpperCase();
    }
    return "";
  }

  get tabDate() {
    if(this.name === "Reservations" && this.reservations && this.reservations?.length > 0 && this.language && this.reservations[this.elementDate].arrivalDate !== undefined)
    {
      const day = DateTime.fromISO(this.reservations[this.elementDate].arrivalDate);
      return " - " + this.firstUpper(day.setLocale(this.language).weekdayLong) + ", "
        + this.firstUpper(day.setLocale(this.language).monthShort) + ". " + day.day
    }
    return "";
  }

  filterModalOpen = false;
  sortModalOpen = false;

  updateFilter(filters: any) {
    this.$emit("filterUpdated", filters);
  }
}

